import React from 'react';
import PropTypes from 'prop-types';
import { IDParamsConfigurationTemplate } from '../templates/IDParamsConfigurationTemplate';
import '../../styles/manage/paramsConfiguration.css';
import ProgressBar from '../../components/ProgressBar';
import { GridComponent, ColumnsDirective, ColumnDirective, Edit, Inject } from '@syncfusion/ej2-react-grids';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { convertFahrenheit, convertCelsius } from '../../components/utils/TemperatureConversion';

import { injectIntl, FormattedMessage } from 'react-intl';

class RefrigerationConfiguration extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            Detail: props.IsConfigurationMenu ? props.Detail : null,
            EnableSave: props?.Detail?.Status === 1
        };
    }

    menuCloseClick() {
        this.gridParamsInstance?.endEdit();
        this.props.MenuCloseClick();
    }

    menuSaveClick() {

        this.gridParamsInstance?.endEdit();
        let refrigerationsT = this.state.Detail.Refrigerations;

        if (this.props.UmTemperature === 'F') {
            for (let i = 0; i < refrigerationsT.length; i++) {
                if (refrigerationsT[i].Type === 'T')
                    refrigerationsT[i].Value = convertCelsius(refrigerationsT[i].Value);
            }
        }

        this.props.SetParams(refrigerationsT);
        this.props.MenuCloseClick();
    }

    shouldComponentUpdate(nextProps) {
        let bShouldUpdate = true;

        if (nextProps?.Detail?.Id === this.state?.Detail?.Id) bShouldUpdate = false;
        if (nextProps?.Detail?.Status !== this.state?.Detail?.Status) bShouldUpdate = true;

        return bShouldUpdate;
    }

    componentDidUpdate() {
        if ((this.props?.SelectedDevices !== undefined) && (this.props?.SelectedDevices?.Id !== this.props?.Detail?.Id)) {
            if (this.state.Detail !== null)
                this.setState({ Detail: null });
            return;
        }
        else {
            let bSetDetail = (this.state.Detail == null);

            if (!bSetDetail)
                bSetDetail = (this.props.Detail.Id !== this.state.Detail.Id) || (this.props.Detail.Status !== this.state.Detail.Status);

            if (bSetDetail) {

                let d = this.props.Detail;

                if (this.props.UmTemperature === 'F') {
                    for (let i = 0; i < d?.Refrigerations?.length; i++)
                        if (d?.Refrigerations[i]?.Type === 'T') {
                            d.Refrigerations[i].Value = convertFahrenheit(d?.Refrigerations[i].Value);
                            d.Refrigerations[i].MinValue = convertFahrenheit(d?.Refrigerations[i].MinValue);
                            d.Refrigerations[i].MaxValue = convertFahrenheit(d?.Refrigerations[i].MaxValue);
                        }
                }

                this.setState({ SelectedCycle: null, Detail: d, EnableSave: this.props?.Detail?.Status === 1 });
            }
        }
    }

    valueTemplateParam(props) {
        if (props.Type === 'T') {
            return (<span>{props.Value}°{this.props.UmTemperature}</span>);
        }

        return null;
    }

    editTemplateParam(props) {

        if (props.Type === 'T') {
            return (
                <NumericTextBoxComponent id='Value' format='n0' min={props.MinValue} max={props.MaxValue} value={props.Value} />
            );
        }

        return null;
    }

    actionComplete(args) {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
            args.dialog.header = this.props.intl?.formatMessage({ id: 'details' }) + ' ' + this.props.intl?.formatMessage({ id: 'refrigeration' });
            if (this.state?.Detail?.DeviceVersion === 'v3') { args.dialog.width = 500; }
        }
    }

    renderRefrigerationConfigurationGrid() {

        if (this.state.Detail === null)
            return (
                <ProgressBar Id='RefrigerationConfiguration' Option={this.props.Option} Message={this.props.intl?.formatMessage({ id: 'waiting' })} />
            );
        else
            return (
                <div id='renderParamsConfiguration'>
                    <GridComponent id='paramsConfigurationGrid' ref={grid => this.gridParamsInstance = grid}
                        dataSource={(this.state.Detail === null) ? null : this.state.Detail.Refrigerations}
                        editSettings={{ allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Dialog' }}
                        allowSorting={false} allowSelection={false} className='comm-grid' actionComplete={this.actionComplete.bind(this)}
                    >
                        <ColumnsDirective>
                            <ColumnDirective field='Name' headerText={this.props.intl.formatMessage({ id: 'id' })} allowEditing={false} template={IDParamsConfigurationTemplate.bind(this)} editTemplate={IDParamsConfigurationTemplate.bind(this)} isPrimaryKey={true}></ColumnDirective>
                            <ColumnDirective field='Value' headerText={this.props.intl.formatMessage({ id: 'value' })}
                                editTemplate={this.editTemplateParam.bind(this)} template={this.valueTemplateParam.bind(this)}>
                            </ColumnDirective>
                        </ColumnsDirective>
                        <Inject services={[Edit]} />
                    </GridComponent>
                </div>
            );
    }

    render() {
        let idTxtSave = 'save';

        if (this.props.Option === 'ConfigurationPage') idTxtSave = 'confirm';
        return (
            <div className='divConfiguration'>
                <div className='row divConfigurationTop'>
                    <div className='col-xs-4 col-md-6 col-lg-7'>
                        <span className='lblValue'><FormattedMessage id='configuration_refrigeration' /></span>
                    </div>
                    <div className='col-xs-8 col-md-6 col-lg-5 btnsTopMenuConfiguration'>
                        <ButtonComponent
                            id='btnSaveConfigurations'
                            onClick={() => this.menuSaveClick()}
                            disabled={(this.props.Option === 'MonitorPage' && !this.state.EnableSave)}
                            iconCss='e-icons e-FB_PV_Save'
                            className='Button'><FormattedMessage id={idTxtSave} /></ButtonComponent>
                        <ButtonComponent
                            id='btnCloseConfigurations'
                            onClick={() => this.menuCloseClick()}
                            iconCss='e-icons e-FT_close'
                            className='ButtonEmpty'><FormattedMessage id='close' /></ButtonComponent>
                    </div>
                </div>
                {this.renderRefrigerationConfigurationGrid()}
            </div>
        );
    }
}

RefrigerationConfiguration.propTypes = {
    SelectedDevices: PropTypes.object,
    Detail: PropTypes.object,
    SetParams: PropTypes.func,
    MenuCloseClick: PropTypes.func,
    intl: PropTypes.object,
    UmTemperature: PropTypes.string,
    IsConfigurationMenu: PropTypes.bool,
    Option: PropTypes.string,
    IsCommSis: PropTypes.bool
};

export default injectIntl(RefrigerationConfiguration);